module.exports = __webpack_public_path__ + "img/carpeta-archivos.33ef09d4.png";